import { Link } from 'react-router-dom';
import { Note } from 'types/notes';
import { isNoteViewedToday } from 'utils/dailyViewTracker';

interface NotesIndex2NoteItemProps {
  note: Note;
  currentNoteId: number;
  page: number;
  pboard?: string;
}

const NotesIndex2NoteItem = ({ note, currentNoteId, page, pboard }: NotesIndex2NoteItemProps) => {
  let noteUrl = `/notes/${pboard || note.pbid || 'notes'}/${note.id}`;
  if (page > 1) noteUrl += `?page=${page}`;

  const isViewed = isNoteViewedToday(note.id);
  const isCurrent = currentNoteId === note.id;

  return (
    <li
      className={`flex items-center w-full gap-2 py-3 px-2 ${isCurrent ? 'bg-gray-100' : ''
        }`}
    >
      <span className="sm:min-w-8 text-sm text-gray-700 text-center">
        {isCurrent ? '→' : note.id}
      </span>
      <Link
        to={noteUrl}
        className={`block text-left text-sm font-medium ${isViewed ? 'text-gray-500' : ''
          } ${isCurrent ? 'pointer-events-none cursor-default' : ''}`}
      >
        {note.title}
      </Link>
      {isViewed && (
        <span className="text-xs text-gray-400 ml-2">✓읽음</span>
      )}
    </li>
  );
};

export default NotesIndex2NoteItem;
